import { useEffect } from 'react';

import { useRetracked } from 'js/lib/retracked';

const useTrackQueryResults = ({ query, totalHits }: { query?: string; totalHits?: number }) => {
  const track = useRetracked();
  useEffect(() => {
    if (query === undefined) return;
    track({
      action: 'search',
      trackingName: 'total_number_of_search_results',
      trackingData: {
        total_number_of_search_results: totalHits,
        searchQuery: query,
      },
    });

    // Because the algolia search state data will update several times on each query update, we use the url query change to track it only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);
};

export default useTrackQueryResults;
